import { Message } from 'element-ui'
import { t } from '@/i18n'
import { checkOrderReconciliation } from '@/utils/api/table'

const pendingChecks = new Map()
const REFUND_CHECK_DELAY_MS = 5 * 60 * 1000

// The read-only check never changes an order; corrections remain in the order list's confirmation flow.
export function scheduleRefundReconciliation (orderId) {
  if (!orderId || pendingChecks.has(orderId)) return

  const timer = setTimeout(async () => {
    pendingChecks.delete(orderId)
    try {
      const res = await checkOrderReconciliation(orderId)
      const data = res.data || {}
      if (data.status !== 1) return
      if (data.need_confirm_fix) {
        Message.warning(t('微信退款已成功但订单仍未更新，请到订单列表点击“核对”并确认修正'))
      } else if (data.level !== 'ok') {
        Message.warning(t('退款状态仍待确认，请到订单列表点击“核对”查看详情'))
      }
    } catch (error) {
      // Reconciliation is optional; the order list retains the manual check entry.
    }
  }, REFUND_CHECK_DELAY_MS)

  pendingChecks.set(orderId, timer)
}
